var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showType == 'form-builder')?_c('b-row',{staticClass:"row-container",class:_vm.selectedElementControlId == _vm.id ? 'row-container-selected' : '',style:(_vm.properties.style),on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.setSelected.apply(null, arguments)}}},[_vm._t("default")],2):(_vm.showType == 'form-submitter' || _vm.showType == 'e-form')?_c('b-row',{style:(_vm.superComputeFormSubmitterValue({
      elementId: this.id,
      property: 'style',
      value: _vm.properties.style,
      defaultValue: '',
      form: this.form
    }))},[_vm._t("default")],2):(_vm.showType == 'form-viewer')?_c('b-row',{style:(_vm.superComputeFormSubmitterValue({
      elementId: this.id,
      property: 'style',
      value: _vm.properties.style,
      defaultValue: '',
      form: this.form
    }))},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }